import React, { useState } from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import Alert from "react-bootstrap/Alert";
import TasksCommentsNew from "../task-create-edit/common-components/tasks-comments-new";
import { LoginContext } from "../../../../services/api/authentication-api";
import "./tasks-comments-panel-new.scss";
import TaskCreateEditComments from "../task-create-edit/common-components/task-create-edit-comments";
import { Button } from "react-bootstrap";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import TaskForm from "../task-form/task-form";
import MemberIconNew from "../../../../components/member-icon-new/member-icon-new";
import { GetFormSubmission } from "../../../../services/api/task-api";
import { NIL as NIL_UUID } from "uuid";
import FluentUiIcon from "../../../../assets/fluent-ui-icon";

const TasksCommentsPanelNew = ({
  show,
  onHide,
  assignID,
  task,
  dateFormatID,
}) => {
  const [alertConfig, setAlertConfig] = useState({
    showAlert: false,
    alertAction: "",
    alertMessage: "",
    alertVariant: "danger",
  });
  const [tags, setTags] = useState([]);
  const [refreshCommentsTable, setRefreshCommentsTable] = useState(0);
  const [newCommentText, setNewCommentText] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [dynamicFields, setDynamicFields] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);
  const [showForm, setShowForm] = useState(true);
  // TAD-5644 — Vite-native env. Vitest now parses import.meta.env directly.
  const isOpenAIKey = import.meta.env.VITE_OPEN_AI_KEY && import.meta.env.VITE_OPEN_AI_KEY !== "";
  const user = React.useContext(LoginContext);
  const labels = user.currentUser?.objectLabels;

  const displayAlert = () => {
    setTimeout(() => {
      setAlertConfig((prevConfig) => ({ ...prevConfig, showAlert: false }));
    }, 5000);

    return (
      <Alert
        show={alertConfig.showAlert}
        onClose={() =>
          setAlertConfig((prevConfig) => ({ ...prevConfig, showAlert: false }))
        }
        variant={alertConfig.alertVariant}
        dismissible
      >
        <Alert.Heading>{alertConfig.alertAction}</Alert.Heading>
        <p>{alertConfig.alertMessage}</p>
      </Alert>
    );
  };

  const setFormModal = async (value) => {
    let result = await GetFormSubmission(value.Comment.Id, assignID);
    if (result.status === 200) {
      value.formdata = result.data;
      setSelectedForm(value);
      setShowFormModal(true);
    }
  };

  let isdisabled =
    task?.StatusId === 2 ||
    task?.StatusId === 3 ||
    task?.StatusId === 8 ||
    task?.isArchived === true ||
    (task?.Permission == "View" && task.CreatedById != task.userID);

  const ViewFormModal = () => {
    return (
      showFormModal && (
        <Modal
          show={showFormModal}
          onHide={() => setShowFormModal(false)}
          contentClassName="formModal"
        >
          <Modal.Header>
            <div>
              <Modal.Title className="modal-title">
                {selectedForm?.formdata?.Label}
              </Modal.Title>
              <div className="form-subtitle">
                <MemberIconNew member={selectedForm?.CreatedBy}></MemberIconNew>
                <span>
                  <div>{selectedForm?.CreatedBy?.Name}</div>
                  <div>{selectedForm?.CreatedBy?.Email}</div>
                </span>
              </div>
            </div>
            <Button
              className="close-document-viewer-btn btn-primary"
              onClick={() => setShowFormModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body className="formModal">
            <FluentProvider theme={webLightTheme}>
              {selectedForm?.formdata?.Id !== NIL_UUID ? (
                <TaskForm
                  FormData={selectedForm?.formdata}
                  IsView={true}
                ></TaskForm>
              ) : (
                <div>Submission not avaialable</div>
              )}
            </FluentProvider>
          </Modal.Body>
        </Modal>
      )
    );
  };

  return (
    <LoginContext.Consumer>
      {(state) => (
        <Modal show={show} onHide={onHide} className="tasks-comments" centered>
          {alertConfig.showAlert && displayAlert()}
          <Modal.Header closeButton>
            <Modal.Title className="actions-title">Audit trail</Modal.Title>
          </Modal.Header>
          <div className="select-member-divider-line"></div>
          <Modal.Body>
            <div className="comments-container comments-list-container">
              {showForm && (
                <TaskCreateEditComments
                  projectTypeId={task.ProjectTypeId}
                  taskTypeId={task.workItemType}
                  dynamicFields={dynamicFields}
                  setDynamicFields={setDynamicFields}
                  touched={{}}
                  taskMembers={task.Members}
                  newCommentText={newCommentText}
                  setNewCommentText={setNewCommentText}
                  selectedFiles={selectedFiles}
                  setSelectedFiles={setSelectedFiles}
                  assignID={assignID}
                  type="standard"
                  tags={tags}
                  setAlertConfig={setAlertConfig}
                  alertConfig={alertConfig}
                  setRefreshCommentsTable={setRefreshCommentsTable}
                  disabled={isdisabled}
                />
              )}
              <TasksCommentsNew
                assignID={assignID}
                type="standard"
                dateFormatID={dateFormatID}
                taskMembers={task.Members}
                workItem={task}
                setTags={setTags}
                setAlertConfig={setAlertConfig}
                alertConfig={alertConfig}
                refreshCommentsTable={refreshCommentsTable}
                setFormModal={setFormModal}
                showForm={showForm}
                setShowForm={setShowForm}
                labels={labels}
              />
              {show && isOpenAIKey && (
                <div
                  className="triyo-ai-button"
                  onClick={() => setShowForm((prev) => !prev)}
                >
                  {showForm ? (
                    <FluentUiIcon
                      name={"BotRegular"}
                      color={"#7405C0"}
                      size={16}
                    />
                  ) : (
                    <FluentUiIcon
                      name={"TextEditStyleRegular"}
                      color={"#0F6CBD"}
                      size={16}
                    />
                  )}
                  <div className="triyo-ai-text pl-2">
                    {showForm ? "TRIYO AI" : "TASK FORM"}
                  </div>
                </div>
              )}
            </div>
          </Modal.Body>
          {ViewFormModal()}
        </Modal>
      )}
    </LoginContext.Consumer>
  );
};

TasksCommentsPanelNew.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  assignID: PropTypes.number.isRequired,
  task: PropTypes.shape({
    ProjectTypeId: PropTypes.number,
    workItemType: PropTypes.number,
    Members: PropTypes.arrayOf(PropTypes.object),
    StatusId: PropTypes.number,
    isArchived: PropTypes.bool,
    Permission: PropTypes.string,
    CreatedById: PropTypes.number,
    userID: PropTypes.number,
  }).isRequired,
  dateFormatID: PropTypes.string.isRequired,
};

export default TasksCommentsPanelNew;
